import Quill from 'quill';
let Inline = Quill.import('blots/inline');

class DnxVariableBlot extends Inline {
    static create(variable) {
        let node = super.create();
        node.setAttribute('title', variable);
        node.setAttribute('contenteditable', false);

        //https://stackoverflow.com/questions/56527353/ngx-quill-quill-js-strip-custom-blots-from-innerhtml
        node.innerText = '';
        setTimeout(() => {
            node.innerText = `${variable.replace('.','_')}`;
        }, 0);

        return node;
    }

    static formats(domNode) {
        return domNode.getAttribute('title') || true;
    }

    format(name, value) {
        if (name === 'dnxVariable' && value) {
          this.domNode.setAttribute('title', value);
          this.domNode.innerText = `${value.replace('.','_')}`;
        } else {
          super.format(name, value);
        }
    }

    formats() {
        let formats = super.formats();
        formats.dnxVariable = DnxVariableBlot.formats(this.domNode);
        return formats;
    }
}

export { DnxVariableBlot as default };
